import gridComponentBase from "@/components/grid/gridComponentBase.vue";
import { Component, Prop } from "vue-property-decorator";
import { TextValueItem } from "../../../models/TextValueItem";
import api from "@/services/api";
import permessi from "@/config/permessi";
import { ProdottiCorrelatiItem } from "@/models/prodotti/prodottiCorrelatiItem";

const _ENDPONT = api.endpoint.PRODOTTI.PRODOTTI_CORRELATI;
@Component({})
export default class ProdottiCorrelati extends gridComponentBase {
	get PERMESSI(): string[] {
		return [permessi.BK.Prodotti.PRODOTTI];
	}
	@Prop({ default: () => null }) pacchettoID: number;
	editItem: ProdottiCorrelatiItem = new ProdottiCorrelatiItem();
	showEditModal: boolean = false;
	editSubTitle: string = "";
	editTitle: string = "";
	kendop: any = kendo;

	tipiCorrelazione: TextValueItem[] = [
		{ value: 0, text: "Correlato" },
		{ value: 1, text: "Ulteriore" },
		{ value: 2, text: "Suggerito su Widget" },
	];
	prodottiVendibili: TextValueItem[] = [];
	prodotti: TextValueItem[] = [];

	get columns(): Array<any> {
		return [
			{ field: "itemID", title: "ID", width: 20, filterable: false, hidden: true, headerCell: "myHeaderCellTemplate", editHide: true },
			{
				field: "pacchettoComplementareID",
				title: this.$i18n.t("generico.prodottoCorrelato").toString(),
				values: this.prodotti,
				headerCell: "myHeaderCellTemplate",
				sortBy: "pacchettoComplementare",
				itemsForFilter: this.prodotti,
				filterType: "select",
				editType: "select",
				editSource: this.prodottiVendibili,
				editDisabled: this.isNewItem ? false : true
			},
			{
				field: "tipo",
				title: this.$i18n.t("generico.tipo").toString(),
				width: 100,
				values: this.tipiCorrelazione,
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				sortBy: "",
				itemsForFilter: this.tipiCorrelazione,
				filterType: "select",
				editType: "select",
				editSource: this.tipiCorrelazione
			},
			{ field: "_actions", title: " ", width: 50 + (this.canDelete ? 50 : 0), cell: "defaultCellTemplate", type: "actions_list", filterable: false, headerCell: "myHeaderCellTemplate" }
		];
	}

	created() {
		var self = this;
		this.take = 60;
		this.pageable.pageSize = 60;
		this.pageSize = 60;
		if (this.group) {
			this.group.map(group => (group.aggregates = this.aggregates));
		}
		this.group = this.group;

		var p = api.getDatiDropDown(api.endpoint.DROPDOWN.PRODOTTI_VENDIBILI).then(res => (self.prodottiVendibili = res));
		var p2 = api.getDatiDropDown(api.endpoint.DROPDOWN.PACCHETTI).then(res => (self.prodotti = res));

		Promise.all([p, p2])
			.then(responses => {
				self.getData();
			})
			.catch(err => {
				console.log(err);
			});
	}

	getData() {
		this.getGridData(`${_ENDPONT}/${this.pacchettoID}`);
	}

	onDelete(item: any) {
		var self = this;
		var message = self.$createElement("div", { domProps: { innerHTML: `<h5>${item.itemID}</h5>${self.$i18n.t("messaggio.confermaCancellazione")}` } }); // h('div', { domProps: { innerHTML: 'Title from <i>HTML<i> string' } })
		var title = this.$i18n.t("titolo.elimina", [this.$i18n.t("generico.prodottoCorrelato")]).toString();
		self.deleteGridRow(_ENDPONT, item.itemID, title, [message]);
	}

	addNewRow() {
		let newItem = new ProdottiCorrelatiItem();
		newItem.pacchettoID = this.pacchettoID;

		this.onEdit(newItem);
	}

	onEdit(item: any) {
		var self = this;
		self.editItem = Object.assign(new ProdottiCorrelatiItem(), item);
		self.editSubTitle = "";
		self.editTitle = item.itemID;
		self.showEditModal = true;
	}

	onSaveEdit() {
		var self = this;
		var title = this.$i18n.t("msg.salvataggioRiuscito").toString();
		var message = this.$i18n.tc("msg.salvato_iCorrettamente", 1, { obj: this.$i18n.t("generico.prodottoCorrelato") }).toString();
		self.setGridRow<ProdottiCorrelatiItem>(_ENDPONT, self.editItem, title, message, self.isNewItem).then(res => {
			self.showEditModal = false;
		});
	}

	get isNewItem(): boolean {
		return (this.editItem || {}).itemID == null || (this.editItem || {}).itemID <= 0;
	}
}
